import { Trans } from 'react-i18next'
import clsx from 'clsx'

import { BuilderPage, IActionFormProps } from '@makyoapp/makyo-common'
import { MaterialIcon } from '@makyoapp/makyo-tw-ui'
import { Button, ButtonVariant, Field, Label, SelectDropdown } from '@makyoapp/makyo-ui'

import { useForm } from '@/lib/use-form'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useVariableTextSingleCell } from '@/hooks/__project__/useVariableTextSingleCell'
import { isEmpty } from '@/shared/utils'

const RenderPageOption = ({ page }: { page: BuilderPage }) => {
  const pageTitle = useVariableTextSingleCell(page.title)
  return (
    <span className='flex items-center'>
      {page?.icon && <MaterialIcon size={20} icon={page.icon ?? 'info'} className='mr-2' />}
      <span className={clsx(!page.id && 'text-light')}>{pageTitle}</span>
    </span>
  )
}

export default function ActFormGoToScreen({ onSubmit, onDismiss, initialData }: IActionFormProps) {
  const { pages } = useAppBuilderContext()
  const pageOptions: BuilderPage[] = pages?.filter((page) => !page.tableId) || []

  const { form, onSubmit: onFormSubmit } = useForm({
    defaultValues: {
      screen: initialData?.screen ?? pageOptions[0].id ?? '',
    },
    validate(values, setError) {
      if (!values.screen?.trim().length) {
        setError('screen', 'Please choose a screen')
      }
    },
  })

  const handleSubmit = onFormSubmit((data) => {
    onSubmit(data)
  })

  const value = form.getValues('screen')
  const invalidForm = isEmpty(value) || !!form.errors

  return (
    <div>
      <div className='p-4'>
        <Field>
          <Label required>Select Screen</Label>

          <div className='flex-1'>
            <SelectDropdown
              multiple={false}
              options={pageOptions}
              optionLabel={(opt) => opt.title}
              value={pageOptions.find(({ id }) => id === form.getValues('screen'))}
              renderOption={(opt) => <RenderPageOption page={opt} />}
              onChange={(page) => {
                form.setValues('screen', page.id)
              }}
            />

            <div className='mt-1 text-m-sm red h-[17px]'>{form.errors?.screen}</div>
          </div>
        </Field>
      </div>

      <div className='px-4 py-2 border-t bdr flex justify-between items-center'>
        <Button variant={ButtonVariant.Outlined} onClick={onDismiss}>
          <Trans>Cancel</Trans>
        </Button>
        <Button onClick={handleSubmit} disabled={invalidForm}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </div>
  )
}
